"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validate;
var _utils = require("./utils");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// validate function
function validate(options) {
  var value = options.value,
    name = options.name,
    label = options.label,
    validations = options.validations,
    message = options.message;
  return new Promise(function (res) {
    var result = (0, _utils.createValidity)(name);
    if (validations.length > 0) {
      var basicProps = {
        key: name,
        label: label || name || 'value',
        message: message
      };
      validations.every(function (v) {
        var validateOption = Object.assign({}, basicProps);
        var validateFunc;
        if (_typeof(v) === 'object' && !Array.isArray(v)) {
          console.warn('Warning: validations props in function \'validate\' will not support object from v0.2.* onwards');
          (0, _utils.assertShape)(v, ['validate', 'options'], 'validation');
          validateFunc = v.validate;
          validateOption = Object.assign(validateOption, v.options); // extends props
        } else {
          validateFunc = v;
        }
        if (validateFunc) {
          try {
            result = validateFunc(value, validateOption);
          } catch (error) {
            result.isValid = false;
            result.message = error.toString();
          }
        }
        return result.isValid;
      });
    }
    res(result);
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/validate.js
// module id = 1884
// module chunks = 0